import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DigitalAssistantService } from '../../../digital-assistant.service';

@Component({
  selector: 'miq-chat-prompts',
  templateUrl: './chat-prompts.component.html',
  styleUrls: ['./chat-prompts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChatPromptsComponent {
  @Input() prompts: string[] = [];
  @Output() emitSelectedPrompt = new EventEmitter<string>();

  constructor(private chatBotService: DigitalAssistantService) {}

  handlePromptClick(prompt: string): void {
    this.chatBotService.isPromptsPanelOpen.update(prev => !prev);
    this.emitSelectedPrompt.emit(prompt);
  }
}
